import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormInputComponent, SharedModule, StringCustomFieldConfig } from '@vendure/admin-ui/core';

@Component({
    selector: 'hidden-form-input',
    template: '<input type="hidden" [formControl]="formControl">',
    standalone: true,
    imports: [SharedModule],
})
export class HiddenFormInputComponent implements FormInputComponent<StringCustomFieldConfig> {
    readonly: boolean;
    formControl: FormControl;
    config: StringCustomFieldConfig;
}
